import axios from 'axios';
import { urlUploads } from '../utils';

export const apiUploads = axios.create({
    baseURL: `${urlUploads}`
});